import { apiClient } from './apiClient';
import { OCRConfig, CreateOCRConfigRequest, UpdateOCRConfigRequest } from '../types';

const BASE_URL = '/admin/ocr-configs';
const TENANT_ACTIVE_URL = '/tenant/me/ocr-configs/domains';

export const ocrConfigService = {
  async list(domain?: string): Promise<OCRConfig[]> {
    const params = new URLSearchParams();
    if (domain) params.append('domain', domain);

    const url = params.toString() ? `${BASE_URL}?${params}` : BASE_URL;
    const response = await apiClient.get<OCRConfig[]>(url);
    return response.data;
  },

  async get(id: string): Promise<OCRConfig> {
    const response = await apiClient.get<OCRConfig>(`${BASE_URL}/${id}`);
    return response.data;
  },

  async getActive(domain: string): Promise<OCRConfig> {
    const response = await apiClient.get<OCRConfig>(`${TENANT_ACTIVE_URL}/${domain}/active`);
    return response.data;
  },

  async create(data: CreateOCRConfigRequest): Promise<OCRConfig> {
    const response = await apiClient.post<OCRConfig>(BASE_URL, data);
    return response.data;
  },

  async update(id: string, data: UpdateOCRConfigRequest): Promise<OCRConfig> {
    const response = await apiClient.patch<OCRConfig>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE_URL}/${id}`);
  },

  async activate(id: string): Promise<OCRConfig> {
    const response = await apiClient.post<OCRConfig>(`${BASE_URL}/${id}/activate`);
    return response.data;
  },
};
